/**
 * Site audit reducer.
 * @module reducers/siteAudit/siteAudit
 */

import { GET_SITE_AUDIT } from '../../constants/ActionTypes';

const initialState = {
  error: null,
  items: [],
  items_total: 0,
  loaded: false,
  loading: false,
};

/**
 * Site audit reducer.
 * @function siteAudit
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
export default function siteAudit(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_SITE_AUDIT}_PENDING`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
      };
    case `${GET_SITE_AUDIT}_SUCCESS`:
      return {
        ...state,
        error: null,
        items: action.result.items,
        items_total: action.result.items_total,
        loaded: true,
        loading: false,
      };
    case `${GET_SITE_AUDIT}_FAIL`:
      return {
        ...state,
        error: action.error,
        items: [],
        items_total: 0,
        loaded: false,
        loading: false,
      };
    default:
      return state;
  }
}
